import { accordionTriggerStyles, FaqSubItem } from './faq-sub-item.component';

import { FaqSubItemType, FaqTopic } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/faq.type';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

type FaqProp = {
  content: FaqTopic[];
  defaultExpandedTopics?: string[];
};

export default function Faq({ content, defaultExpandedTopics }: FaqProp) {
  return (
    <div className="md:mb-6 xl:mb-10">
      <div className="flex w-full justify-center bg-white sm:rounded-xxl">
        <div className="grid w-full md:rounded-xxl">
          <Accordion
            type="multiple"
            defaultValue={defaultExpandedTopics}
            className="border border-gray-300 md:rounded-xxl bg-white -mx-6 md:mx-0 "
          >
            {content.map((mainItem, index) => (
              <AccordionItem key={`key-main-item-${mainItem.title}`} value={mainItem.title}>
                <AccordionTrigger
                  underlineOnHover={false}
                  className={accordionTriggerStyles({
                    className: 'px-11 py-5 md:px-6',
                    withBorder: index < content.length && index > 0,
                  })}
                  data-analytics-event={AnalyticsEnum.CLICK_FAQ_QUESTION_TOPIC}
                  data-analytics-properties={JSON.stringify({ question: mainItem.title })}
                >
                  <Typography
                    variant={TypographyVariant.MEDIUM_SUBTITLE}
                    className="font-semibold text-green-600 text-start"
                  >
                    {mainItem.title}
                  </Typography>
                </AccordionTrigger>

                <AccordionContent className="px-6">
                  <hr className="md:mx-5" />
                  <Accordion type="multiple">
                    {mainItem.subitems.map((item: FaqSubItemType) => (
                      <FaqSubItem
                        key={`key-faq-subitem-${item.title}`}
                        item={item}
                      />
                    ))}
                  </Accordion>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
